<div class="pnf-container">
  <img class="pnf-img" src="assets/images/page_not_found.png" alt="" />
  <div class="text-container">
    <h5>{{ 'PAGE_NOT_FOUND.TITLE' | translate }}</h5>
    <h6>{{ 'PAGE_NOT_FOUND.MESSAGE' | translate }}</h6>
  </div>
  <custom-button [text]="'PAGE_NOT_FOUND.BACK_TO_HOME' | translate" [routerLink]="'/'"></custom-button>
</div>
